import { useUploads } from '../useUploads'
import { collectResults } from 'utils/query'
import { getMediaFiles } from '../getMediaFiles'
import { ACCEPTED_IMAGE_AND_VIDEO_MIME_TYPES } from 'screens/Finder/components/views/GalleryView/constants'
import Styles from './UploadsDrawer.module.scss'
import { UploadedFile } from '../UploadedFile'
import { Button } from 'blaze-ui/Button'

export const UploadsPanel = () => {
  const uploadsQuery = useUploads()
  const uploads = collectResults(uploadsQuery, (data) => data.files)
  const mediaFiles = getMediaFiles(uploads, ACCEPTED_IMAGE_AND_VIDEO_MIME_TYPES)

  const { hasNextPage, fetchNextPage } = uploadsQuery

  return (
    <div>
      <div className={Styles.sectionContainer}>
        <div className={Styles.groupItems}>
          {mediaFiles.map((file) => (
            <div key={file.id} className={Styles.mediaFileContainer}>
              <UploadedFile file={file} />
            </div>
          ))}
        </div>
      </div>
      {hasNextPage && (
        <div className={Styles.seeMoreButton}>
          <Button fullWidth variant="tertiary" size="lg" onPress={() => fetchNextPage()}>
            See More
          </Button>
        </div>
      )}
    </div>
  )
}
